import type { GetParentalCodeStatusResponse } from '@dce-front/types-acm';
import type { AcmSdkConfig } from '../config/types';
import type { AcmApi } from '../constants/paths';
import { fetchAcm } from '../helpers/fetchAcm';

/** @category Function parameters */
export type GetParentalCodeStatusParameters = AcmSdkConfig & {
  passToken: string;
};

/** Fetch **getParentalCodeStatus** ACM Api */
export async function getParentalCodeStatus({
  passToken,
  ...acmSdkConfig
}: GetParentalCodeStatusParameters): Promise<GetParentalCodeStatusResponse> {
  const api: AcmApi = 'getParentalCodeStatus';

  const getParentalCodeStatusResponse = await fetchAcm({
    acmSdkConfig: {
      ...acmSdkConfig,
      fetchOptions: {
        ...acmSdkConfig.fetchOptions,
        headers: {
          ...acmSdkConfig.fetchOptions?.headers,
          passToken,
          'Content-Type': 'application/json',
        },
      },
    },
    api,
  });

  return getParentalCodeStatusResponse as GetParentalCodeStatusResponse;
}
